import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/Login.vue'
import Error401 from '@/components/Error401'
import Home from '@/views/home'

import InDex from '@/views/index'
import Index from '@/views/book/index'

import Library from '@/views/book/library'
import ReceiveBook from '@/views/book/receiveBook'

import buyCourse from '@/views/course/buyCourse'//自有课程
import CourseList from '@/views/course/courseList'//课程列表
import AddCourse from '@/views/course/addCourse'//新建课包
import DetailCourse from '@/views/course/detailCourse'//新建课包
import DetailbuyCourse from '@/views/course/detailbuyCourse'//新建课包
import PackageCourseDetail from '@/views/course/packageCourseDetail'//课包详情
import Grant from '@/views/course/grant'//课包详情
import DetailAuthorization from '@/views/course/detailAuthorization'//授权课包详情
import DetailOil from '@/views/course/detailOil'//授权加油包详情


import StuList from '@/views/stu/stuList'//学员管理
import LearnStatistic from '@/views/stu/learnStatistic'//学情统计
import AddStu from '@/views/stu/addStu'//新建学员
import DetailStu from '@/views/stu/detailStu'//学员详情
import StuHistory from '@/views/stu/stuHistory'//操作日志
import AddBook from '@/views/book/addBook'
import AddAginBook from '@/views/book/addBook'
import DoLogs from "@/views/course/doLogs"
import DoAuthor from "@/views/course/doAuthor"

import MultyAddBook from '@/views/book/multyaddbook'
import AddContent from '@/views/book/addContent'
import AddAlbum from '@/views/book/addAlbum'
import TeacherList from '@/views/teacher/teacherList'//老师管理
import AddTeacher from '@/views/teacher/addTeacher'//新建老师
import DetailsTeacher from '@/views/teacher/detailsTeacher'//老师详情

import ClassList from '@/views/class/classList'//班级管理
import AddClass from '@/views/class/addClass'//新建班级


import ContentSection from '@/views/operation/contentSection' //内容专区
import PrefectureShare from '@/views/operation/prefectureShare' //专区分享
import AddSection from '@/views/operation/addSection' //新建板块
import AudioResources from '@/views/operation/audioResources' //音频资源上传
import AddAlbums from '@/views/operation/addAlbums' //新建专辑
import Institution from '@/views/operation/institution' //机构
import InvitationDetail from "@/views/operation/invitationDetail"

import UserInfo from '@/views/user/userInfo.vue'
import ExtraDetail from '@/views/course/extraDetail'
import Myextra from '@/views/course/myextra'
import ExtraAddNew from '@/views/course/extraAddNew'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: InDex
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/error',
      name: 'Error',
      meta: {
        hideInMenu: true
      },
      component: Error401
    },
    {
      path: '/',
      component: Home,
      meta: { requiresAuth: process.env.ENABLE_AUTH, mainMenuId: 'root' },
      children: [
        // {
        //   path: '/',
        //   name: 'index',
        //   component: Index
        // },
        {
          path: '/index',
          name: 'index',
          component: Index
        },
        {
          path: '/library',
          name: 'library',
          component: Library
        },
        // 课程
        {
          path: '/buycourse',
          name: 'buycourse',
          meta: {},
          component: buyCourse
        },
        {
          path: '/courseList',
          name: 'courseList',
          meta: {},
          component: CourseList
        },
        {
          path: 'addCourse',
          name: 'addCourse',
          component: AddCourse,
          meta: {}
        },
        {
          path: 'detailCourse',
          name: 'detailCourse',
          component: DetailCourse,
          meta: {}
        },
        {
          path: 'extradetail',
          name: 'extraDetail',
          component: ExtraDetail
        },
        {
          path: 'detailbuyCourse',
          name: 'detailbuyCourse',
          component: DetailbuyCourse,
          meta: {}
        },
        {
          path: 'detailAuthorization',
          name: 'detailAuthorization',
          component: DetailAuthorization,
          meta: {}
        },
        {
          path: 'detailOil',
          name: 'detailOil',
          component: DetailOil,
          meta: {}
        },
        {
          path: 'packageCourseDetail',
          name: 'packageCourseDetail',
          component: PackageCourseDetail,
          meta: {}
        },
        {
          path: 'extraAddNew',
          name: 'extraAddNew',
          component: ExtraAddNew,
          meta: {}
        },
        {
          path: 'myextra',
          name: 'myextra',
          component: Myextra,
          meta: {}
        },
        {
          path: 'stulist',
          name: 'stulist',
          component: StuList,
          meta: {}
        },
        {
          path: 'learnStatistic',
          name: 'learnstatistic',
          component: LearnStatistic,
          meta: {}
        },
        {
          path: 'grant',
          name: 'grant',
          component: Grant,
          meta: {}
        },
        {
          path: 'addStu',
          name: 'addStu',
          component: AddStu,
          meta: {}
        },
        {
          path: 'detailStu',
          name: 'detailStu',
          component: DetailStu,
          meta: {}
        },
        {
          path: 'teacherlist',
          name: 'teacherlist',
          component: TeacherList,
          meta: {}
        },
        {
          path: 'addTeacher',
          name: 'addTeacher',
          component: AddTeacher,
          meta: {}
        },
        {
          path: 'detailsTeacher',
          name: 'detailsTeacher',
          component: DetailsTeacher,
          meta: {}
        },
        {
          path: 'classlist',
          name: 'classlist',
          component: ClassList,
          meta: {}
        },
        {
          path: 'addClass',
          name: 'addClass',
          component: AddClass,
          meta: {}
        },
        {
          path: 'stuHistory',
          name: 'stuHistory',
          component: StuHistory,
          meta: {}
        },
        {
          path: '/addbook',
          name: 'addbook',
          component: AddBook,
        },
        {
          path: '/addAginbook',
          name: 'addAginbook',
          component: AddAginBook,
        },
        {
          path: '/multyaddbook',
          name: 'multyaddbook',
          component: MultyAddBook,
        },
        {
          path: '/addcontent',
          name: 'addcontent',
          component: AddContent,
        },
        {
          path: '/albums/addAlbum',
          name: 'addAlbum',
          component: AddAlbum,
        },
        {
          path: '/course/doLogs',
          name: 'doLogs',
          component: DoLogs,
        },
        {
          path: '/course/doAuthor',
          name: 'doAuthor',
          component: DoAuthor,
        },
        {
          path: 'borrow',
          name: 'borrow',
          component: ReceiveBook,
        },
        {
          path: '/myinfo',
          name: 'userinfo',
          component: UserInfo


        },
        {
          path: '/contentSection',
          name: 'contentSection',
          component: ContentSection,
        },
        {
          path: '/prefectureShare',
          name: 'prefectureShare',
          component: PrefectureShare,
        },
        {
          path: '/addSection',
          name: 'addSection',
          component: AddSection,
        },
        {
          path: '/addAlbums',
          name: 'addAlbums',
          component: AddAlbums,
        },
        {
          path: '/audioResources',
          name: 'audioResources',
          component: AudioResources,
        },
        {
          path: '/institution',
          name: 'institution',
          component: Institution,
        },
        {
          path: '/invitationDetail',
          name: 'invitationDetail',
          component: InvitationDetail,
        },
      ]
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js